module.exports = [
    'در حال تحلیل داده‌ها ...',
    'علائم کافی برای غربال اتیسم مشاهده نشده است',
    'بر اساس پاسخ‌های شما در این ارزیابی، احتمال برخی علائم اتیسم وجود دارد',
    'می‌توانید برای انجام ارزیابی‌های بیشتر، با موسسه منتخب خود تماس حاصل فرمایید',
    "بر اساس پاسخ‌های شما در این ارزیابی، علائم اتیسم وجود دارد.",
    'برای بررسی بیشتر به یک فوق تخصص اطفال یا به یک مرکز اتیسم مراجعه نمایید',
    'بازگشت به صفحه اصلی',
]